"use strict";
import JSBI from "jsbi";
import { sqrt } from "@uniswap/sdk-core";
export function encodeSqrtRatioX96(amount1, amount0) {
  const numerator = JSBI.leftShift(JSBI.BigInt(amount1), JSBI.BigInt(192));
  const denominator = JSBI.BigInt(amount0);
  const ratioX192 = JSBI.divide(numerator, denominator);
  return sqrt(ratioX192);
}
